import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { withoutSystem, withSystem } from '../../data/salesContent';
export function ComparisonSection() {
  return <section className="bg-cream px-5 py-20 md:py-28" data-id="element-84" data-mp="515usco5gf9i">
      <div className="mx-auto max-w-5xl" data-id="element-85" data-mp="52qpc2agry7d">
        <SectionHeading title="Buscar todo por separado vs. tener un kit organizado." data-id="element-86" data-mp="9yo4i59zqyik" />
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-87" data-mp="3rffi0igcfh8p">
          <div className="rounded-2xl border border-line bg-cream-deep p-7 md:p-9" data-id="element-88" data-mp="3rduomw5rm4cf">
            <h3 className="font-serif text-xl uppercase tracking-wide text-ink-muted md:text-2xl" data-id="element-89" data-mp="2ku6c4zjtkj">Sin el kit</h3>
            <ul className="mt-6 space-y-4" data-id="element-90" data-mp="3id6be3o7480l">
              {withoutSystem.map(i => <CheckItem key={i} variant="cross" className="text-lg text-ink-muted" data-id="element-91" data-mp="3nf5erdjxr4xj">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-sage bg-white p-7 shadow-lg shadow-ink/5 md:p-9" data-id="element-92" data-mp="3dgpkj1pm3fjt">
            <h3 className="font-serif text-xl uppercase tracking-wide text-sage-dark md:text-2xl" data-id="element-93" data-mp="z6xzuloyv6nu">Con el kit</h3>
            <ul className="mt-6 space-y-4" data-id="element-94" data-mp="u7l3998aml82">
              {withSystem.map(i => <CheckItem key={i} className="text-lg font-medium text-ink" data-id="element-95" data-mp="1885lo4aaqf11">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
        </div>
        <p className="mx-auto mt-14 max-w-3xl text-center font-serif text-2xl uppercase leading-snug text-ink md:text-4xl" data-id="element-96" data-mp="144pon6ubecnt">
          Menos tiempo buscando. <span className="text-rose-dark" data-id="element-97" data-mp="bixyysxxxzvj">Más claridad para acompañar a tu bebé.</span>
        </p>
      </div>
    </section>;
}